// Import CSS
import '../css/app.css';
import 'photoswipe/dist/photoswipe.css';
import '../css/plugins/photoswipe.css';

// Import modules
import { initLazyLoadWithServd } from './modules/lazyLoad';
import { initGalleryWithServd } from './modules/gallery';
import { initCookieBanner } from './modules/cookieBanner';
import { initEmailRevealWithServd } from './modules/emailReveal';
import { initScroll } from './modules/scroll';
import { initServdListeners } from './modules/servdUtils';

// Initialize modules when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize Servd event listeners first
  initServdListeners();
  
  // Initialize lazy loading for images (Servd compatible)
  initLazyLoadWithServd();
  
  // Initialize PhotoSwipe galleries (Servd compatible)
  initGalleryWithServd();
  
  // Initialize cookie banner if present
  if (document.querySelector('.cookie-banner')) {
    initCookieBanner();
  }
  
  // Initialize email reveal buttons (Servd compatible)
  initEmailRevealWithServd();
  
  // Initialize smooth scrolling
  initScroll();
});

// Handle YLE iframe resizing
window.addEventListener('message', (event) => {
  if (event.data?.type === 'YLE-iframe-size-event') {
    const frame = document.getElementById('testFrame');
    if (frame) {
      frame.height = event.data.dimensions.height;
      frame.width = event.data.dimensions.width;
    }
  }
});

// Note: PhotoSwipe is now imported as an ES module above
// import("../../node_modules/photoswipe/dist/photoswipe.js");
// import("../../node_modules/photoswipe/dist/photoswipe-ui-default.js");
